import styled from "styled-components";

export const StyledHint = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px;
    color: #8c8c8c;
    font-size: 13px;
`;
